import { Box, Menu } from "@mui/material";
import { CrossButton } from "../../../assets/common-svg/CommonSvg";
import { useFormik } from "formik";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { LoadingButton } from "@mui/lab";
import * as Yup from 'yup'
import { FormCommentList } from "../../../components/form-template/FormCommentList";
import { useDispatch, useSelector } from "react-redux";
import { queryChat, raisedQuery, rejectQuery, resolvedQuery, selectQueryLoading } from "../../../bmr/slices/queryPreScreen";
import { returnPostData } from "./common";
import {  updatePreScreenForm } from "../../../bmr/slices/appointment";
import { getValueByPath } from "../../../utils/utils"
import { notify } from "../../../bmr/utils/methods/notification";
import { selectCurrentCycle } from "../../../bmr/slices/common"
import moment from 'moment';

const validationSchema = Yup.object().shape({
    comment: Yup.string()
        .required("Comment is required")
        .max(200, "Enter less than 200 characters"),
});

const PreScreenComment = ({handleMenuClose, anchorEl, open, queryData, selectedField, checkPreScreenForm, getPrimaryDiagnosis, formValues, handleManualFormikValidaction }) => {
    const dispatch = useDispatch()
    const LoginData = useSelector((state) => state.loginData);
    // const userAuthority = LoginData?.auth || [];
    const role_id = LoginData?.role_id
    const role_slug = LoginData?.role_slug;
    const isEditorPM = role_id === 5 || role_slug === "project-manager";
    const isLoading = useSelector(selectQueryLoading)
    const currentCycle = useSelector(selectCurrentCycle)
   const allDecimalFields = ["ferritin","alc","anc","hb","baseline_ldh_level","baseline_crp_level","lvef_percentage","number_of_lines_of_therapies_prior_to_car_t","patient_body_weight","lvef_percentage", "b_all_blast_percentage"];
    const initialValues = {
        comment: ""
    }


    const handleSubmit = async (values) => {
        let finalVal = selectedField?.is_file ? selectedField.field_value : `${selectedField.field_value}`;
        if(selectedField.field_label == 'Date of last Relapse/Refractoriness' || selectedField.field_name == 'date_of_last_relapse_or_refractoriness')
         finalVal =  selectedField.field_value ? moment(selectedField.field_value, "DD/MM/YYYY", true).format("MM/YYYY"): "";
               const data = {
            prescreening_id: selectedField?.prescreening_id,
            patient_id: selectedField.patient_id,
            field_id: selectedField.field_id,
            data: {
                "is_file": selectedField?.is_file,
                "field_label": selectedField.field_label ?? selectedField?.field_name,
                "field_name": selectedField.field_name,
                "field_value": finalVal,
                "query": values.comment,
                "type": 1,
                "resolve_by": selectedField?.isResolve
            }
        }
        if (selectedField?.field_id && selectedField?.resolve == 0) {
            await dispatch(queryChat({ id: selectedField?.field_id, data: { query: values?.comment, resolve_by: selectedField?.isResolve
                } }))
        } else {
            await dispatch(raisedQuery(data))
        }
        getPrimaryDiagnosis()
        handleMenuClose()
    }

    const updateForm = async (data) => {
        await dispatch(updatePreScreenForm({ id: selectedField.prescreening_id, data: data }))
    }

    const resolvedOurQuery = async () => {
          await formik.validateForm();
        if (!formik?.values?.comment?.trim() || !formik?.isValid) {
                return notify.error('Please add the comment')
            }
        handleMenuClose();
        let check = await handleManualFormikValidaction()
        if (check == 1) {
            try {
                const result = returnPostData(formValues);
                const data = {
                    ...result,
                    preferable_leukapheresis_dates: JSON.stringify(result.preferable_leukapheresis_dates),
                    treatment_history: JSON.stringify(result.treatment_history),
                    last_treatment_dates: JSON.stringify(result.last_treatment_dates),
                }
                const oldValue = getValueByPath(checkPreScreenForm, selectedField?.field_name) || '';
                let newValue = getValueByPath(data, selectedField?.field_name) || '';               
                if (oldValue == newValue || oldValue?.toString() === newValue?.toString()) {
                  notify.error("Please change the field's value first, then resolve query.")
                } else {
                 let finalValue = selectedField?.field_value
                     if(allDecimalFields.includes(selectedField.field_name)){
                     finalValue = newValue?.toFixed(2)
                    }
                    if(selectedField.field_label == 'Date of last Relapse/Refractoriness' || selectedField.field_name == 'date_of_last_relapse_or_refractoriness')
                         finalValue =  selectedField.field_value ? moment(selectedField.field_value, "DD/MM/YYYY", true).format("MM/YYYY"): "";
            
                    updateForm(data)
                    await dispatch(resolvedQuery({ id: selectedField.field_id, data: { new_value: finalValue, is_file: selectedField?.is_file,resolve_by: selectedField?.isResolve} }))
                    getPrimaryDiagnosis();
                }
            } catch (error) {
                console.error("Error in resolvedOurQuery:", error);
            }
        }
    }

    const rejectOurQuery = async () => {
    await dispatch(rejectQuery({id:selectedField.field_id,data:{resolve_by: selectedField?.isResolve,feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id}}));
        getPrimaryDiagnosis()
        handleMenuClose()
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: handleSubmit
    })

    const formOptions = {
        type: 'textarea',
        disabled: false,
        required: true,
        name: 'comment',
        placeholder: 'Enter Comment',
    }

    return <div>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
        >
            <Box className="p-2">
                <div className="flex flex-row-reverse border-b border-gray-300 pb-2">
                    <p className="flex gap-1 mr-3">
                        <span className="cursor-pointer" onClick={() => handleMenuClose()}>
                            <CrossButton />
                        </span>
                    </p>
                </div>
                <div className="p-3">
                    {queryData?.length != 0
                        ? <FormCommentList
                            loading={isLoading}
                            MenuData={queryData.map(op => { return { name: `${op.raised_by[0]}${op.raised_by[1]}`, title: op.raised_by, describe: op.query, date: op.created_at, ...op } })}
                        />
                        : (
                            ''
                        )}
                </div>
                <form className="" onSubmit={formik.handleSubmit}>
                    <FormikControl formik={formik} {...formOptions} className="mt-2" />
                    <div className="flex gap-2 mt-2">
                        {(!isEditorPM || (isEditorPM && selectedField?.id && selectedField?.resolve == 0)) && (
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={isLoading}
                                className="disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Submit
                            </LoadingButton>
                        )}
                        {(isEditorPM) && (
                        <LoadingButton
                            type="button"
                            disabled={isLoading || selectedField?.resolve != 0}
                            onClick={() => resolvedOurQuery()}
                            className="!bg-[#00B278] disabled:!bg-[#A0D9C7] disabled:cursor-not-allowed"
                            color="success"
                            variant="contained"
                            fullWidth
                        >
                            Resolve
                        </LoadingButton>
                        )}

                        <LoadingButton
                            type="button"
                            disabled={isLoading || selectedField?.resolve !== 0}
                            onClick={() => rejectOurQuery()}
                            className={`!border-[#FF2023] !text-[#FF2023] 
                                        ${isLoading || selectedField?.resolve !== 0
                                    ? '!border-[#FCA5A5] !text-[#FCA5A5] cursor-not-allowed opacity-50'
                                    : ''}`}
                            variant="outlined"
                            fullWidth
                        >
                            Reject
                        </LoadingButton>

                    </div>
                </form>
            </Box>
        </Menu>
    </div>
}

export default PreScreenComment;